import { render } from "./Denied.vue?vue&type=template&id=59d21098&scoped=true&lang=pug"
import script from "./Denied.vue?vue&type=script&lang=js"
export * from "./Denied.vue?vue&type=script&lang=js"

import "./Denied.vue?vue&type=style&index=0&id=59d21098&lang=scss&scoped=true"

import exportComponent from "C:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d21098"]])

export default __exports__